<template>
  <div class="menu-child">
    <div class="flex align-center menu-body" :class="{'is-active': chooseMenuId === menuInfo.id, 'width-child': menuInfo.children && menuInfo.children.length}" :style="{paddingLeft: step * 20 + 'px'}">
      <i class="el-icon-arrow-down mr-5" :class="{'is-open' : isOpen}" v-if="menuInfo.children && menuInfo.children.length" @click="onClickMenu"></i>
      <div :class="{'font-bold': menuInfo.children && menuInfo.children.length, 'is-open' : isOpen}" class="menu-title-small flex-1 text-left" @click="onClickMenu" v-if="specialItem===1">{{menuInfo.name + ' '+ menuInfo.specialItem }}</div>
      <div :class="{'font-bold': menuInfo.children && menuInfo.children.length, 'is-open' : isOpen}" class="menu-title-small flex-1 text-left justify-center" @click="onClickMenu" v-else>
        <div v-if="!isReport">{{menuInfo.name}}</div>
        <el-tooltip v-else effect="dark" :content="menuInfo.name" placement="right">
          <div class="flex-nowrap" style="white-space:nowrap;overflow:hidden;text-overflow:ellipsis;">{{menuInfo.name}}</div>
        </el-tooltip>
      </div>
      <div class="btn-container" v-if="!notOperate">
        <i class="el-icon-circle-plus-outline mr-5" v-if="!notAdd" @click.stop="onAdd(menuInfo)"></i>
        <i class="el-icon-edit mr-5" @click.stop="onEdit(menuInfo)"></i>
        <div v-if="!cateType">
          <i class="el-icon-circle-close" @click.stop="onDelete(menuInfo)"></i>
        </div>
        <div v-else>
          <i class="el-icon-circle-close" @click.stop="onDelete(menuInfo)" v-if="cateType==1 && permission.includes('deleteMaterialClassify')"></i>
          <i class="el-icon-circle-close" @click.stop="onDelete(menuInfo)" v-if="cateType==2 && permission.includes('deleteQuotaClassify')"></i>
          <i class="el-icon-circle-close" @click.stop="onDelete(menuInfo)" v-if="cateType==3 && permission.includes('deleteBusinessClassify')"></i>
        </div>
      </div>
    </div>
    <template v-if="menuInfo.children && menuInfo.children.length">
      <cate-child-menu :step="step + 1" :specialItem=specialItem :permission="permission" :not-operate="notOperate" :not-add="notAdd" v-show="isOpen" v-for="(child, idx) in menuInfo.children" :key="idx" :menu-info="child" :choose-id="chooseMenuId"  @on-edit="onEdit" @on-delete="onDelete" @on-choose="onChooseMenu" @on-add="onAdd"></cate-child-menu>
    </template>
  </div>
</template>

<script>
export default {
  name: 'CateChildMenu',
  components: {},
  props: ['menuInfo', 'step', 'chooseId', 'notOperate', 'notAdd', 'specialItem', 'permission', 'cateType', 'isReport'],
  watch: {
    chooseId (newV, oldV) {
      this.chooseMenuId = newV
    }
  },
  data () {
    return {
      menu: this.menuInfo,
      isOpen: false,
      chooseMenuId: this.chooseId
    }
  },
  created () {
  },
  mounted () {},
  methods: {
    onClickMenu () {
      if (this.menuInfo.children && this.menuInfo.children.length) {
        this.isOpen = !this.isOpen
      }
      this.onChooseMenu(this.menuInfo)
    },
    onChooseMenu (menu) {
      this.$emit('on-choose', menu)
    },
    onAdd (menu) {
      this.$emit('on-add', menu)
    },
    onDelete (menu) {
      this.$emit('on-delete', menu)
    },
    onEdit (menu) {
      this.$emit('on-edit', menu)
    }
  }
}
</script>

<style lang="scss" scoped>
.menu-child {
  min-height: 35px;
  width: 100%;
  border-top: dashed 1px #e2e2e2;
  line-height: 35px;
  .menu-title-small {
    font-size: 12px;
    color: #30313a;
    word-break: keep-all;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .btn-container {
    padding: 0 10px;
    display: flex;
    align-items: center;
    i {
      font-size: 14px;
      color: #e2e2e2;
    }
  }
  .el-icon-arrow-down {
    font-size: 14px;
    color: #30313a;
    transition: transform .3s;
    margin-bottom: 2px;
    font-weight: bold;
  }
  .is-open {
    &.menu-title-small, &.el-icon-arrow-down {
      color: #f5971d;
    }
    &.el-icon-arrow-down {
      transform: rotate(180deg);
    }
  }
  .is-active {
    background: #f5971d;
    .menu-title-small, .el-icon-arrow-down {
      color: #ffffff;
    }
  }
  .menu-body:hover, .is-active {
    cursor: pointer;
    .btn-container {
      i {
        color: #30313a;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/CateChildMenu.vue